import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateSchedule } from '../../../../state';

const IntervalEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value) || 1;
    dispatch(updateSchedule({ interval: value }));
  };

  const type = currentRecurringTask?.schedule?.type || 'DAILY';
  const label = type === 'DAILY' ? 'Every N Days' : 
                type === 'WEEKLY' ? 'Every N Weeks' :
                'Every N Months';

  return (
    <TextField
      label={label}
      value={currentRecurringTask?.schedule?.interval || 1}
      onChange={handleChange}
      size="small"
      type="number"
      required
      sx={{ minWidth: 150 }}
      InputProps={{ inputProps: { min: 1, max: 365 } }}
    />
  );
};

export default IntervalEdit;
